export default __webpack_public_path__ + "d3bc0387e24b0fb66c32b5a4a38b18ba.svg";